export default class TOC extends Component {
  render() {
    const { width, chapters } = this.props
    const H1 = ({ children, chapter }) => (
      <Surface
        flexFlow="row"
        marginTop={20}
        marginBottom={5}
        alignItems="center"
      >
        <Text size={600} fontWeight={500}>
          {children}
        </Text>
        <Text size={600} marginLeft={10} opacity={0.6}>
          Chapter {chapter}
        </Text>
      </Surface>
    )
    const H2 = ({ children, ...props }) => (
      <Text fontSize={18} marginY={6} marginLeft={10} {...props}>
        {children}
      </Text>
    )

    return (
      <Surface
        height={window.innerHeight}
        padding={20}
        paddingTop={200}
        background="white"
        alignItems="center"
        width={width}
      >
        <Surface>
          <Text size={500} fontWeight={500}>
            Table of Contents
          </Text>
          {chapters.map(({ title, sections }, index) => (
            <React.Fragment>
              <H1 chapter={index + 1}>{title}</H1>
              {sections.map(({ title, published }) => (
                <React.Fragment>
                  <H2 opacity={published ? 1 : 0.4}>{title}</H2>
                </React.Fragment>
              ))}
            </React.Fragment>
          ))}
        </Surface>
      </Surface>
    )
  }
}
